import React from 'react'
import Accordion from 'react-bootstrap/Accordion';

const Freaquent = () => {
    return (
        <div className='frequntly'>

            <h1 className='text-center'>Frequently Asked Questions</h1>

            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>1. At what time can I visit this doctor?</Accordion.Header>
                    <Accordion.Body>
                        Dr. Raj Kumar Sharma (Medanta Super Speciality Hospital) in Sushant Golf City is open during Medanta OPD from Monday to Saturday )
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>2. Does this doctor have any field of specialisation?</Accordion.Header>
                    <Accordion.Body>
                        Dr. Raj Kumar Sharma (Medanta Super Speciality Hospital) specialises in.
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                    <Accordion.Header>3. Can you give me a landmark to locate Dr. Raj Kumar Sharma (Medanta Super Speciality Hospital) in Sushant Golf City?</Accordion.Header>
                    <Accordion.Body>
                        Dr. Raj Kumar Sharma (Medanta Super Speciality Hospital) is very easy to find as it is located right Pocket 1, Sector A in Sushant Golf City, Lucknow
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

        </div>
    )
}

export default Freaquent